
import { useNavigate, useParams } from "react-router-dom";
import { useMutationGenerateCommentaryTracker, useMutationUpdateCommentaryTracker, useQueryCommentaryTracker } from "./queries/TrackerCommentaryQueries";
import { Box, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { setCommentaryEditKey } from "../OotrReducer";
import CommentaryPlayerTracker from "./CommentaryPlayerTracker";
import { ItemLightDto } from "../../core/items/ItemDataTypes";
import { useSelector } from "react-redux";
import { AppState } from "../../core/app/AppReducer";
import { useEffect } from "react";
import { useQueryClient } from "react-query";





const CommentaryScreen = () => {

    //user can generate a tracker session with a code
    let {id} = useParams<{id: string}>()
    let dispatch = useDispatch();

    let nav = useNavigate();

    let client = useQueryClient()
    let { data } = useQueryCommentaryTracker(Number(id))

    let generate = useMutationGenerateCommentaryTracker()
    let update = useMutationUpdateCommentaryTracker(Number(id))

    let editKey = useSelector((state: AppState) => state.ui.ootr.main.commentaryEditKey)


       useEffect(() => {
   
           let interval = setInterval(() => {
            
            client.invalidateQueries("commentary-tracker/"+id)
       
           }, 500);
       
           return () => clearInterval(interval);
    
             // eslint-disable-next-line react-hooks/exhaustive-deps
       }, []);

    const generateCommentaryTracker = async () => {
        let result = await generate.mutateAsync();
        dispatch(setCommentaryEditKey(result))
        nav("/ootr/commentary/"+ result.id);   
    }

    const updatePlayer1Item = async (item: ItemLightDto) => {
        console.log("Update item player 1", item, data.player1Items)
        if(item.isObtained || item.state !== 0)
            await update.mutateAsync({...data, editKey: editKey.filter(x => x.id === Number(id))?.[0]?.editKey , player1Items: [...data.player1Items.filter(x => x.id !== item.id), item] } )
        else
            await update.mutateAsync({...data, editKey: editKey.filter(x => x.id === Number(id))?.[0]?.editKey , player1Items: [...data.player1Items.filter(x => x.id !== item.id)] } )
    }

    const updatePlayer2Item = async (item: ItemLightDto) => {
       
        if(item.isObtained || item.state !== 0)
            await update.mutateAsync({...data, editKey: editKey.filter(x => x.id === Number(id))?.[0]?.editKey , player2Items: [...data.player2Items.filter(x => x.id !== item.id), item] } )
        else
            await update.mutateAsync({...data, editKey: editKey.filter(x => x.id === Number(id))?.[0]?.editKey , player2Items: [...data.player2Items.filter(x => x.id !== item.id)] } )
    }

    //retrieve data of commentary
    //Json string item must be cast as array of Itemlightdto
    //inject the list in all display items

    //do the same for always, path, sometimes
   

    //declare the update function
    //pass it to children tracker on OoTItem to reflect the change in database

    return <>
        <Button onClick={generateCommentaryTracker}>Generate</Button> 
        <Box position='absolute' width="600px">
            <CommentaryPlayerTracker items={data.player1Items} updateItem={updatePlayer1Item} />

        </Box>
        <Box position='absolute' left={"600px"}>
            <CommentaryPlayerTracker items={data.player2Items} updateItem={updatePlayer2Item} /> 
        </Box>
    </>
}

export default CommentaryScreen;